module.exports = __webpack_public_path__ + "img/solution-aviation.ca646fd3.jpg";